import { sipExtensionQueueResponseSchema, sipExtensionQueueStateSchema } from '@easyflow/shared';

interface QueueFeedback {
  type: 'success' | 'warning';
  message: string;
  savedLoggedIn: boolean | undefined;
}

export function getSipExtensionQueueFeedback(data: unknown): QueueFeedback {
  const saved = sipExtensionQueueStateSchema.safeParse(data);
  if (!saved.success) {
    return {
      type: 'warning', savedLoggedIn: undefined,
      message: 'Esito accesso alle code non confermato. Ricarica lo stato prima di riprovare.',
    };
  }
  const prefix = `Preferenza di accesso alle code ${saved.data.queue_logged_in ? 'attiva' : 'disattiva'} salvata.`;
  const parsed = sipExtensionQueueResponseSchema.safeParse(data);
  if (!parsed.success) {
    return {
      type: 'warning', savedLoggedIn: saved.data.queue_logged_in,
      message: `${prefix} Il dettaglio dell’aggiornamento telefonico non è disponibile. Verifica lo stato prima di riprovare.`,
    };
  }
  const outcome = parsed.data.freeswitch_update;
  if (outcome.state === 'command_accepted') {
    return {
      type: 'success', savedLoggedIn: saved.data.queue_logged_in,
      message: `${prefix} FreeSWITCH ha accettato l’aggiornamento dello stato dell’agente.`,
    };
  }
  if (outcome.state === 'not_applied') {
    const reason: Record<typeof outcome.reason, string> = {
      tenant_unavailable: 'Impossibile risolvere il tenant: nessun comando telefonico inviato.',
      node_unavailable: 'Nodo FreeSWITCH non disponibile: nessun comando telefonico inviato.',
      queues_unavailable: 'Impossibile leggere le code attive: nessun comando telefonico inviato.',
      no_active_queues: 'Nessuna coda attiva: nessun comando telefonico inviato.',
      command_rejected: 'FreeSWITCH ha rifiutato l’aggiornamento dello stato dell’agente.',
    };
    return { type: 'warning', savedLoggedIn: saved.data.queue_logged_in, message: `${prefix} ${reason[outcome.reason]}` };
  }
  const reason: Record<typeof outcome.reason, string> = {
    timeout: 'Tempo di attesa scaduto: esito telefonico non confermato.',
    command_error: 'Errore durante il comando: esito telefonico non confermato.',
    unexpected_response: 'Risposta telefonica non riconosciuta: esito non confermato.',
    partial_application: 'I comandi hanno restituito esiti discordanti: aggiornamento completo non confermato.',
  };
  return {
    type: 'warning', savedLoggedIn: saved.data.queue_logged_in,
    message: `${prefix} ${reason[outcome.reason]} Verifica lo stato prima di riprovare.`,
  };
}
